import { gql } from '@apollo/client';

export const CLONE_EXTERNAL_TICKETS_JOURNEY_SEARCH = gql`
  query cloneExternalTicketsJourneySearch(
    $origin: String!
    $destination: String!
    $outboundDate: String
    $currency: Currency
    $productFamilies: [String]
    $contractCode: String
    $passengers: [InputPassengerBrief]
    $discountCards: [InputDiscountCard]
    $isYouthAdultConversionActive: Boolean
    $useNewLoyaltySystem: Boolean
    $seniorsAges: [Int!]
    $youthAges: [Int!]
    $childAges: [Int!]
    $maxTransfers: Int
    $trainNumbers: [String]
  ) {
    journeySearch(
      origin: $origin
      destination: $destination
      outboundDate: $outboundDate
      currency: $currency
      productFamilies: $productFamilies
      contractCode: $contractCode
      passengersList: $passengers
      discountCards: $discountCards
      isYouthAdultConversionActive: $isYouthAdultConversionActive
      useNewLoyaltySystem: $useNewLoyaltySystem
      seniorsAges: $seniorsAges
      youthAges: $youthAges
      childAges: $childAges
      maxTransfers: $maxTransfers
    ) {
      outbound {
        journeys(trainNumbers: $trainNumbers, hideDirectExternalCarrierTrains: false, hideExternalCarrierTrains: false) {
          fares {
            classOfService {
              code
              name
            }
            canBeBooked
            bookingItems {
              passengerId
              tariffCode
              price
              isAFareAddOn
            }
            legs {
              trainNumber
              serviceName
              serviceIdentifier
              origin {
                uic
              }
              destination {
                uic
              }
              timing {
                departureDate
                departs
              }
              classOfService {
                code
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const CANCEL_EXTERNAL_TICKETS = gql`
  mutation cloneExternalTicketsCancel(
    $bookingReference: String!
    $itemRefs: [String]!
    $overrideReason: String
    $overrideAftersalesRules: Boolean
  ) {
    cancelSpecificBookingItems(
      bookingReference: $bookingReference
      itemRefs: $itemRefs
      overrideReason: $overrideReason
      overrideAftersalesRules: $overrideAftersalesRules
    ) {
      cancellable
    }
  }
`;
